// Mock data for Rainbow Worldwide

const U = (id, w = 1000) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
const P = (url, w = 1000) => `${url}?auto=compress&cs=tinysrgb&w=${w}`;

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Work", href: "#work" },
  { label: "Contact Us", href: "#contact" },
];

export const hero = {
  eyebrow: "EXHIBITION STAND DESIGN & BUILD",
  title: "Exhibition Stand Design & Build Across India",
  description:
    "From the first concept to the final dismantling, Rainbow Worldwide manages your exhibition stand design, engineering, fabrication, transportation and installation through one dedicated point of contact.",
  image: U("photo-1761225646548-bc92fea0dc72", 1200),
};

export const about = {
  eyebrow: "ABOUT RAINBOW WORLDWIDE",
  heading: "Complete Exhibition Stand Solutions",
  intro:
    "Rainbow Worldwide provides end-to-end exhibition stand services for Indian companies and international brands participating in exhibitions across India.",
  image: U("photo-1572021335469-31706a17aaef", 1100),
  blocks: [
    {
      title: "End-to-End Management",
      text: "We manage the complete process — from the initial design brief through to on-site installation and post-show dismantling — through a single dedicated project contact.",
    },
    {
      title: "What We Deliver",
      text: "Our work spans custom stand design, structural engineering, fabrication, branded graphics, furniture and AV coordination, transportation and installation.",
    },
    {
      title: "Built Around Your Brand",
      text: "Each project is developed around your specific brand, stand dimensions, product displays and visitor engagement objectives.",
    },
  ],
};

export const services = [
  {
    icon: "PencilRuler",
    title: "Stand Design & 3D Visualisation",
    desc: "Concepts developed around your brand, stand dimensions and visitor engagement objectives. Reviewed in 3D before production begins.",
    image: U("photo-1647320293733-92affa4fa39c"),
    tag: "3D Design Concept",
  },
  {
    icon: "Wrench",
    title: "Engineering & Fabrication",
    desc: "Structural design and construction of stand frameworks, display units, counters and meeting areas.",
    image: U("photo-1564182842834-681b7be6de4b"),
  },
  {
    icon: "Palette",
    title: "Graphics & Branding",
    desc: "Logos, large-format printed graphics, signage and branded display elements integrated into the stand design.",
    image: U("photo-1693031630369-bd429a57f115"),
  },
  {
    icon: "Lightbulb",
    title: "Furniture, Lighting & AV",
    desc: "Appropriate furniture, lighting, screens and presentation equipment coordinated within the agreed project scope.",
    image: P("https://images.pexels.com/photos/31311141/pexels-photo-31311141.jpeg"),
  },
  {
    icon: "Truck",
    title: "Transport, Installation & Dismantling",
    desc: "Coordination of stand materials, venue installation and post-show dismantling.",
    image: U("photo-1504307651254-35680f356dfd"),
  },
  {
    icon: "ClipboardList",
    title: "Project Management",
    desc: "Scheduling, communication and on-site coordination through a single dedicated project contact.",
    image: U("photo-1532619675605-1ede6c2ed2b0"),
  },
];

export let projects = [
  {
    title: "Pharmaceutical Brand Stand",
    client: "Pharma Pro India",
    location: "Mumbai, India",
    size: "36 sqm",
    desc: "Custom island stand with meeting room and product display.",
    image: U("photo-1761195689615-9469b65dac01"),
  },
  {
    title: "Technology Exhibitor",
    client: "Electronics India",
    location: "Bengaluru, India",
    size: "54 sqm",
    desc: "Two-storey stand with demo zones and branded reception.",
    image: P("https://images.pexels.com/photos/19012048/pexels-photo-19012048.jpeg"),
  },
  {
    title: "Manufacturing Sector Stand",
    client: "India Manufacturing Show",
    location: "Chennai, India",
    size: "48 sqm",
    desc: "Open-plan stand with integrated product presentation areas and meeting space.",
    image: P("https://images.pexels.com/photos/36522033/pexels-photo-36522033.jpeg"),
  },
];

export const process = [
  { num: "01", title: "Share Your Brief", desc: "Submit your exhibition details, floor plan, stand dimensions and budget." },
  { num: "02", title: "Concept & 3D Design", desc: "We develop the stand concept and present 3D visuals for your review." },
  { num: "03", title: "Scope & Quotation", desc: "We confirm materials, inclusions, exclusions and provide a clear quotation." },
  { num: "04", title: "Fabrication & Preparation", desc: "Stand components are engineered and prepared for the exhibition." },
  { num: "05", title: "Transport & Installation", desc: "Materials are transported to the venue and the stand is installed." },
  { num: "06", title: "Dismantling", desc: "After the exhibition closes, we coordinate the dismantling and removal." },
];

export const whyUs = {
  heading: "Why Work With Rainbow Worldwide",
  points: [
    "One dedicated point of contact from brief to dismantling",
    "Design and construction coordinated by the same team",
    "Clear scope and transparent quotations — inclusions and exclusions confirmed in writing",
    "Stand layouts planned around your branding, product displays and visitor meetings",
    "Project coordination covering preparation, installation and post-show dismantling",
  ],
  body:
    "Rainbow Worldwide brings structured project management and industry experience to every exhibition stand project in India. Our approach is transparent and focused on delivering a stand that works for your brand and your exhibition objectives.",
  image: P("https://images.pexels.com/photos/35138560/pexels-photo-35138560.jpeg", 1100),
};

export const contact = {
  email: "info@rainbowworldwide.co.in",
  phone: "+91 7503775437",
};

export const footer = {
  description:
    "Complete exhibition stand design and construction services for Indian companies and international brands exhibiting across India.",
  services: [
    "Stand Design & 3D Visualisation",
    "Engineering & Fabrication",
    "Graphics & Branding",
    "Furniture, Lighting & AV",
    "Transport & Installation",
    "Project Management",
  ],
  quickLinks: ["Home", "About Us", "Our Work", "Contact Us"],
};

// Browser-managed image overrides. Defaults remain if settings are unavailable.
export function applyPictureSettings(settings) {
  const slots = {hero, about, whyUs};
  services.forEach((item, i) => slots[`service-${i}`] = item);
  projects.forEach((item, i) => slots[`project-${i}`] = item);
  for (const [key, value] of Object.entries(settings || {})) {
    const item = slots[key];
    if (!item || !value || typeof value !== 'object') continue;
    if (typeof value.image === 'string' && /^\/uploads\/[a-f0-9]{32}\.(jpg|png|webp)$/.test(value.image)) item.image = value.image;
    if (key.startsWith('project-')) {
      for (const field of ['title','client','location','size','desc']) if (typeof value[field] === 'string') item[field] = value[field];
      item.actual = value.actual === true;
    }
  }
}

export function applyShowSettings(data) {
  if (!data || !Array.isArray(data.shows)) return;
  const safePhoto = url => typeof url === 'string' && (/^\/uploads\/[a-f0-9]{32}\.(jpg|png|webp)$/.test(url) || /^https:\/\/(images\.unsplash\.com|images\.pexels\.com)\//.test(url));
  projects = data.shows.slice(0,100).filter(show => show && typeof show.title === 'string' && Array.isArray(show.photos)).map(show => {
    const photos = show.photos.filter(safePhoto).slice(0,20);
    const cover = Number.isInteger(show.cover) && show.cover >= 0 && show.cover < photos.length ? show.cover : 0;
    return {...show, photos, image: photos[cover], actual: show.actual === true};
  }).filter(show => show.photos.length > 0);
}
